import { render, staticRenderFns } from "./EmployeeSkillCard.vue?vue&type=template&id=57f01830&scoped=true&"
import script from "./EmployeeSkillCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeSkillCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSkillCard.vue?vue&type=style&index=0&id=57f01830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f01830",
  null
  
)

export default component.exports
import {QBanner,QItem,QInput,QChip,QSelect,QToggle,QBtn,QToolbar,QSpace} from 'quasar'
component.options.components = Object.assign({QBanner,QItem,QInput,QChip,QSelect,QToggle,QBtn,QToolbar,QSpace}, component.options.components || {})
